<template>
  <div>
    <div>
      <div v-if="variation.template">
        <b-form @submit.prevent="confirm">
          <b-form-group
            id="input-group-1"
            label="Antall deltakere"
            label-for="participants"
            description="Hvis produktet selges for 2 personer, som for eks. Ølsmaking for to så skal antallet justeres for dette. Hvis man ønsker 10 personer, så skriver dere 5 i dette feltet."
          >
            <div slot="label">
              Antall deltakere
              <i
                v-b-tooltip.hover
                title="Oppgi antall personer som kan melde seg på valgt dato."
                class="fa fa-info-circle hoverable"
              ></i>
            </div>
            <b-form-input
              id="participants"
              v-model="form.participants"
              type="number"
              required
              placeholder="10"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Velg start-tid">
            <div slot="label">
              Velg start-tid
              <i
                v-b-tooltip.hover
                title="Velg tidspunkt for når opplevelsen starter."
                class="fa fa-info-circle hoverable"
              ></i>
            </div>
            <timeselector
              v-model="form.starts_at"
              :returnFormat="'HH:mm'"
              :displayFormat="'HH:mm'"
              :padTime="true"
            ></timeselector>
          </b-form-group>
          <b-form-group label="Velg slutt-tid">
            <div slot="label">
              Velg slutt-tid
              <i
                v-b-tooltip.hover
                title="Velg tidspunkt for når opplevelsen slutter."
                class="fa fa-info-circle hoverable"
              ></i>
            </div>
            <timeselector
              v-model="form.ends_at"
              :returnFormat="'HH:mm'"
              :displayFormat="'HH:mm'"
              :padTime="true"
            ></timeselector>
          </b-form-group>
          <b-form-group
            id="input-group-1"
            label="Bookingfrist"
            label-for="last_bookable"
            description="0 lar kunden booke helt frem til start-tid på oppgitt dato. 1 lar kunde booke inntil 24 timer før start-tid."
          >
            <div slot="label">
              Bookingfrist
              <i
                v-b-tooltip.hover
                title="Oppgi hvor mange dager før start-tid opplevelsen kan bookes."
                class="fa fa-info-circle hoverable"
              ></i>
            </div>
            <b-form-input
              id="last_bookable"
              v-model="form.last_bookable_date"
              type="number"
              required
              placeholder="1"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-2"
            label="Velg datoer"
            label-for="date-pick"
          >
            <div slot="label">
              Velg datoer
              <i
                v-b-tooltip.hover
                title="Velg en eller flere datoer som oppgitt informasjon gjelder for."
                class="fa fa-info-circle hoverable"
              ></i>
            </div>
            <v-date-picker
              locale="nb"
              is-expanded
              :columns="$screens({ default: 1, lg: 2 })"
              id="date-pick"
              v-model="dates"
              mode="multiple"
              is-inline
            />
          </b-form-group>
          <b-button type="submit" variant="primary" :disabled="!dates.length"
            >Legg til {{ dates.length > 1 ? "datoer" : "dato" }}</b-button
          >
        </b-form>
      </div>
      <div v-else>
        <p>
          {{ variation.variaton_name }} er ikke aktivert og det er derfor ikke
          mulig å legge til ny dato for denne opplevelsen. Vennligst kontakt
          YouWish for å få aktivert bookingsystemet.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Timeselector from "@/components/booking/Timeselector.vue";
import { mapGetters } from "vuex";
import { booking } from "@/api";
import { format, parse, parseISO } from "date-fns";

export default {
  props: ["variation"],
  components: {
    Timeselector,
  },
  data() {
    const { formDefault, datesDefault } = this.formDefault();
    return {
      form: formDefault,
      dates: datesDefault,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
    }),
  },
  methods: {
    formDefault() {
      const date = new Date();
      const endDate = new Date();

      const startAt = this.variation.template.starts_at.split(":");
      const endsAt = this.variation.template.ends_at.split(":");

      date.setHours(startAt[0], startAt[1]);
      endDate.setHours(endsAt[0], endsAt[1]);

      return {
        formDefault: {
          participants: this.variation.template.participants,
          starts_at: date,
          ends_at: endDate,
          last_bookable_date: this.variation.template.last_bookable_date,
        },
        datesDefault: [],
      };
    },
    resetForm() {
      const { formDefault, datesDefault } = this.formDefault();
      this.form = formDefault;
      this.dates = datesDefault;
    },
    confirm() {
      this.addDates()
        .then(()=>{
          this.$bvToast.toast(
              'Takk! Din informasjon er nå lagret.',
              {
                variant: "success",
                title: "Dato lagt till",
                autoHideDelay: 2000,
              }
            )

            setTimeout(()=>{ this.$router.push({ name: 'bookings' }) }, 2000)
        })
    },
    async addDates() {
      await booking.template
        .update(this.variation.template.id, {
          participants: this.form.participants,
          last_bookable_date: this.last_bookable_date,
          starts_at: format(new Date(this.form.starts_at), "HH:mm"),
          ends_at: format(new Date(this.form.ends_at), "HH:mm"),
        })
        .then(() => {
          this.dates.forEach((date) => {
            booking.dates.create(this.variation.id, {
              booking_template_id: this.variation.template.id,
              date: format(new Date(date), "y-MM-dd"),
              confirmed: true,
            });
          });
        })
        .then(() => {
          this.resetForm();
        });
    },
  },
};
</script>

<style>
</style>
